var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMh = function SvgMh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M12 24c6.627 0 12-5.373 12-12 0-2.014-.497-3.912-1.373-5.578l-10.641 5.592 5.592-10.64A11.947 11.947 0 0 0 12 0C5.373 0 0 5.373 0 12c0 3.314 1.343 6.314 3.515 8.485A11.962 11.962 0 0 0 12 24Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M22.614 6.434a11.998 11.998 0 0 0-2.142-2.906c-.88-.879-1.861-1.593-2.907-2.142L3.501 20.499 22.614 6.434Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9811",
    d: "M3.501 20.5 22.614 6.434a11.998 11.998 0 0 0-2.142-2.906L3.5 20.499Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m10.42 7.037-1.465.69.78 1.419-1.591-.305-.202 1.608-1.108-1.183-1.109 1.183-.201-1.608-1.592.305.78-1.42-1.465-.69 1.466-.689-.78-1.419 1.59.305.202-1.608 1.109 1.182 1.108-1.182.202 1.608 1.591-.305-.78 1.42 1.465.689Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgMh;